import { InteractionStatus } from '@azure/msal-browser';
import useMsalUser from '@shared/hooks/useMsalUser';
import { IAuthService } from '@shared/providers/AuthProvider';

export interface IUseAuthService extends IAuthService {
    authService: IAuthService;
    inProgress: InteractionStatus;
}

// To call this, must be within a MSAL context
export default function useAuthService(): IUseAuthService {
    const { getUser, isAuthenticated, getIdToken, inProgress } = useMsalUser();

    const authService: IAuthService = {
        getToken: getIdToken,
        getUser: getUser,
        isAuthenticated: () => isAuthenticated,
    };
    return { authService, ...authService, inProgress };
}
